import classNames from 'classnames/bind';
import useTranslation from 'next-translate/useTranslation';
import { getRemainingDays } from 'utils/date';
import styles from './JobDdayBadge.module.css';

const cx = classNames.bind(styles);

interface IJobDdayBadgeProps {
  deadline: string | null;
}

function JobDdayBadge({ deadline }: IJobDdayBadgeProps) {
  const { t } = useTranslation('recruit-jobs');

  if (!deadline) return <span className={cx('dday')}>{t('always-open')}</span>;

  const remainingDays = getRemainingDays({ deadline });
  if (remainingDays === null) return null;

  return (
    <span className={cx('dday')}>
      {remainingDays === 0
        ? t('dday-today')
        : t('dday', { days: remainingDays })}
    </span>
  );
}

export default JobDdayBadge;
